module.exports = __webpack_public_path__ + "static/img/k1.c554194.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/k1.png
// module id = 287
// module chunks = 0 1 2 3 4 5 6 7 8 9